import classNames from 'classnames'
import { format } from 'date-fns'
import { forwardRef } from 'react'
import { Button, ButtonIconPosition, Icon } from '@opallabs/lapidary'
import { DatePickerStyleSelectors, DatePickerStyleStates } from './styles'
import type { DisplayProps } from './types'

export const SelectDisplay = forwardRef<HTMLButtonElement, DisplayProps>(
  (
    {
      ariaLabel,
      buttonCss,
      buttonVariant = 'tertiary',
      className,
      dateDisplayFormat,
      disabled,
      htmlId,
      placeholder,
      selectedDate,
      /* eslint-disable @typescript-eslint/no-unused-vars --
         Used only for ButtonDisplay, but destructured so they are not
         splatted onto the Button with the Radix props: an undefined
         buttonText would override the date. */
      ariaLive,
      buttonText,
      iconPosition,
      showButtonText,
      /* eslint-enable @typescript-eslint/no-unused-vars */
      ...radixPopoverProps
    },
    ref
  ) => (
    <Button
      ariaLabel={ariaLabel}
      buttonText={
        selectedDate ? format(selectedDate, dateDisplayFormat) : placeholder
      }
      className={classNames([
        DatePickerStyleSelectors.root,
        className,
        { [DatePickerStyleStates.hasValue]: Boolean(selectedDate) },
      ])}
      disabled={disabled}
      styleOverrides={{ button: buttonCss }}
      ref={ref}
      name="date-picker"
      id={htmlId}
      icon={<Icon glyph="gem-calendar" />}
      iconPosition={ButtonIconPosition.leading}
      displayMenuIndicator={true}
      menuIndicatorPosition={ButtonIconPosition.trailing}
      variant={buttonVariant}
      {...radixPopoverProps}
    />
  )
)

SelectDisplay.displayName = 'Satellite: DatePicker ← SelectDisplay'
